import { Container, Row, Col, Card } from 'react-bootstrap';
import './index.css';

const PayByCardSuccess = () => {

    return (
        <Container fluid className="payment-success-container d-flex align-items-center justify-content-center">
            <Row className="w-100 justify-content-center">
                <Col md={6} lg={5}>
                    <Card className="success-card border-0">
                        <Card.Body className="p-4 p-md-5 text-center">

                            {/* Success Icon */}
                            <div className="mb-4">
                                <div className="success-icon d-inline-flex align-items-center justify-content-center rounded-circle mb-3">
                                    <div className="check-mark"></div>
                                </div>
                            </div>

                            {/* Success Message */}
                            <h2 className="text-success fw-bold mb-3">Payment Successful! 🎉</h2>
                            <p className="text-muted mb-4">
                                Thank you for your payment. Your order has been confirmed and will be processed shortly.
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default PayByCardSuccess;